import React from "react";
import { Alert } from "@mui/material";
import { getActiveClientBrandConfig } from "../../../config/environment.config";
import useTailwindBrand from "src/Theme/useTailwindBrand";

interface AddressChangeAlertProps {
    /** Raison de l'invalidation renvoyée par le backend */
    reason?: string | null;
}

/**
 * Bannière affichée quand la dernière attestation signée n'est plus valable
 * (adresse de l'élève modifiée, changement de mode…) : re-signature requise.
 */
const AddressChangeAlert = ({ reason }: AddressChangeAlertProps) => {
    const {classes} = useTailwindBrand();
    return (
        <Alert severity="warning" variant="outlined" className={`mb-4 ${classes.fontFamily}`}>
            Votre précédente attestation de déplacement pour ce {getActiveClientBrandConfig()} n'est
            plus valable{reason ? <>- <span className="font-semibold">{reason}</span></> : ", son adresse ayant changé"}.
            Merci de signer une nouvelle attestation pour continuer.
        </Alert>
    );
};

export default AddressChangeAlert;
